import { render, staticRenderFns } from "./Datasets.vue?vue&type=template&id=7653412e&scoped=true"
import script from "./Datasets.vue?vue&type=script&lang=js"
export * from "./Datasets.vue?vue&type=script&lang=js"
import style0 from "./Datasets.vue?vue&type=style&index=0&id=7653412e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7653412e",
  null
  
)

export default component.exports